import {
  ProductPriceTierPatchRequestType,
  ProductPriceTierPatchResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductPriceTierPatchV2 = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductPriceTierPatchRequestType) =>
      apiV2Request({
        user,
        business,
        method: "patch",
        path: `product-price-tiers/v2`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as ProductPriceTierPatchResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductPriceTiersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductPriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.ProductAssignment],
      });
    },
  });
};
